import { render } from "./Tools.vue?vue&type=template&id=a2c63a96"
import script from "./Tools.vue?vue&type=script&lang=js"
export * from "./Tools.vue?vue&type=script&lang=js"
script.render = render

export default script